const ASC = 'asc';
const DESC = 'desc';

export const sortingDirection = {
  ASC,
  DESC,
};
